import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { FiArrowLeft, FiEdit2, FiCalendar, FiClock, FiMapPin, FiUsers } from 'react-icons/fi';
import api from '../../services/api';
import { formatarDataReuniaoLonga } from '../../utils/reuniaoDate';
import PresencasReuniaoPanel from '../Presencas/PresencasReuniaoPanel';
import './DetalhesReuniao.css';

const DetalhesReuniao = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [reuniao, setReuniao] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchReuniao = useCallback(async () => {
    try {
      const response = await api.get(`/reunioes/${id}`);
      const data = response.data?.data ?? response.data;
      setReuniao(data);
    } catch (error) {
      console.error('Erro ao buscar reunião:', error);
      navigate('/reunioes');
    } finally {
      setLoading(false);
    }
  }, [id, navigate]);

  useEffect(() => {
    fetchReuniao();
  }, [fetchReuniao]);

  const formatDate = (dateString) => formatarDataReuniaoLonga(dateString);

  const formatTime = (timeValue) => {
    if (!timeValue) return '--:--';
    // Prisma retorna horaInicio/horaFim como ISO datetime (ex: "1970-01-01T12:00:00.000Z")
    if (typeof timeValue === 'string' && timeValue.includes('T')) {
      const d = new Date(timeValue);
      return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    }
    // Formato simples "HH:MM:SS" ou "HH:MM"
    return String(timeValue).substring(0, 5);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'agendada': return 'status-agendada';
      case 'em_andamento': return 'status-em-andamento';
      case 'concluida': return 'status-concluida';
      case 'cancelada': return 'status-cancelada';
      default: return '';
    }
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  if (!reuniao) {
    return <div className="error">Reunião não encontrada.</div>;
  }

  return (
    <div className="detalhes-reuniao-page">
      <div className="page-header">
        <button
          onClick={() => navigate('/reunioes')}
          className="btn btn-secondary"
        >
          <FiArrowLeft size={20} />
          Voltar
        </button>
        <div className="header-actions">
          <Link
            to={`/reunioes/${id}/editar`}
            className="btn btn-primary"
          >
            <FiEdit2 size={20} />
            Editar
          </Link>
        </div>
      </div>

      <div className="reuniao-details">
        <div className="reuniao-header">
          <h1>{reuniao.titulo}</h1>
          <span className={`status ${getStatusColor(reuniao.status)}`}>
            {(reuniao.status ?? '').replace('_', ' ')}
          </span>
        </div>

        <div className="reuniao-info">
          <div className="info-item">
            <FiCalendar className="icon" />
            <span>{formatDate(reuniao.data ?? reuniao.dataReuniao)}</span>
          </div>
          <div className="info-item">
            <FiClock className="icon" />
            <span>{formatTime(reuniao.horaInicio ?? reuniao.hora_inicio)} - {formatTime(reuniao.horaFim ?? reuniao.hora_fim)}</span>
          </div>
          {reuniao.local && (
            <div className="info-item">
              <FiMapPin className="icon" />
              <span>{reuniao.local}</span>
            </div>
          )}
          <div className="info-item">
            <FiUsers className="icon" />
            <span>
              {reuniao._count?.reuniaoParticipantes ?? reuniao.total_participantes ?? 0} participantes
            </span>
          </div>
        </div>

        {reuniao.descricao && (
          <div className="reuniao-description">
            <h3>Descrição</h3>
            <p>{reuniao.descricao}</p>
          </div>
        )}

        <section id="presencas-registro" className="participantes-section participantes-presencas-unica">
          <div className="section-header">
            <h3>Participantes e presenças</h3>
          </div>
          <p className="participantes-presencas-lead">
            Lista por cargo. Marque presente ou ausente e salve — o mesmo registro da tela de presenças.
          </p>
          <PresencasReuniaoPanel reuniaoId={id} embedded onSalvo={fetchReuniao} />
        </section>
      </div>
    </div>
  );
};

export default DetalhesReuniao; 